import client from "./clients/portalClient";

const getAllServiceHosting = () => client.get(`/service_hosting`);

const serviceHostingApi = {
  getAllServiceHosting,
};

export default serviceHostingApi;
